import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AgentInsurerDetailsComponent } from "./lead/agent-insurer-details/agent-insurer-details.component";
import { PropertyDetailsComponent } from "./lead/property-details/property-details.component";
import { LiabilityDetailsComponent } from "./lead/liability-details/liability-details.component";
import { OptionalCoveragesComponent } from "./lead/optional-coverages/optional-coverages.component";
import { UwQuestionsComponent } from "./lead/uw-questions/uw-questions.component";
import { QuoteSummaryComponent } from "./lead/quote-summary/quote-summary.component";
import { AuthGuardService } from "./core/services/authguard.service";
import { SSOLoginComponent } from "./lead/sso-login/sso-login.component";
import { CallbackComponent } from "./lead/callback/callback.component";
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';


export const routes: Routes = [
  { path: "",  redirectTo: "/agent",pathMatch: "full" },
  { path:"login", redirectTo:"/agent", pathMatch:"full"},
  { path:"callback", component:CallbackComponent, data:{routeId:'Callback'}},
  { path: "SSOLogin", component: SSOLoginComponent,canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'SSOLogin'} },
  { path: "agent", component: AgentInsurerDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'AgentDetails'} },
  { path: "property-details", component: PropertyDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'PropertyDetails'} },
  { path: "liability-details", component: LiabilityDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] , data: { routeId:'LiabilityDetails'}},
  { path: "optional-coverages", component: OptionalCoveragesComponent, canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'OptionalCoverage'} },
  { path: "uw-questions", component: UwQuestionsComponent, canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'UWQuestions'} },
  { path: "quote-summary", component: QuoteSummaryComponent, canActivate: [AutoLoginPartialRoutesGuard], data: { routeId:'QuoteSummary'} },
];
